var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7208 10.5087C13.7409 10.5087 12.7788 10.3554 11.8671 10.054C11.4203 9.9016 10.8711 10.0414 10.5984 10.3216L8.79879 11.6805C6.71175 10.5661 5.42618 9.28055 4.32733 7.20854L5.64587 5.45528C5.98844 5.11307 6.11131 4.61317 5.9641 4.14413C5.6615 3.22731 5.50779 2.26533 5.50779 1.28472C5.50783 0.576318 4.93169 0 4.22355 0H1.28428C0.576141 0 0 0.576318 0 1.28468C0 9.40433 6.60368 16.01 14.7208 16.01C15.429 16.01 16.0051 15.4337 16.0051 14.7253V11.7934C16.0051 11.085 15.4289 10.5087 14.7208 10.5087Z",
    fill: "#3AB100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterphone);
export default __webpack_public_path__ + "static/media/footerphone.4f1969cea01c0d147bfe8362c171754f.svg";
export { ForwardRef as ReactComponent };